// extracted by mini-css-extract-plugin
module.exports = {"categoryListContainer":"_2oIQv","title":"_1l618"};